import { Menu } from './menu.model';

export const verticalMenuItems = [ 
    new Menu (1, 'Dashboard', '/home/dashboard', null, 'tachometer', null, false, 0, true),
     
      new Menu (3, 'User Management',  '/home/UserShow/User', null, 'user', null, false, 0, true), 
      new Menu (2, ' Question', '/home/QuestionsData/Questions', null, 'user', null, false, 0, true),
      new Menu (4, 'Answers',  '/home/Answers/Answer', null, 'user', null, false, 0, true),  
      new Menu (5, 'Images',  '/home/Images/Img', null, 'user', null, false, 0, true),  
      new Menu (6, 'Soil Report', '/home/Report/SoilReport', null, 'user', null, false, 0, true), 
      new Menu (7, 'Block User', '/home/BlockUsersView/BlockUsers', null, 'user', null, false, 0, true), 
  
    new Menu (45, 'Blank', '/blank', null, 'file-o', null, false, 40, true),
    new Menu (46, 'Error', '/pagenotfound', null, 'exclamation-circle', null, false, 40, true),
  
   
]

export const horizontalMenuItems = [ 
    new Menu (1, 'Dashboard', '/home/dashboard', null, 'tachometer', null, false, 0, true),
   
  
    // new Menu (5, 'Block Post', '/home/BlockPost/viewpost', null, 'user', null, false, 0, true),
    new Menu (3, 'User Management',  '/home/UserShow/User', null, 'user', null, false, 0, true), 
    new Menu (2, 'Question', '/home/QuestionsData/Questions', null, 'user', null, false, 0, true), 
    new Menu (4, 'Answers',  '/home/Answers/Answer', null, 'user', null, false, 0, true),  
    new Menu (5, 'Images',  '/home/Images/Img', null, 'user', null, false, 0, true),  
    new Menu (6, 'Soil Report', '/home/Report/SoilReport', null, 'user', null, false, 0, true), 
    new Menu (7, 'Block User', '/home/BlockUsersView/BlockUsers', null, 'user', null, false, 0, true), 
    // new Menu (6, ' Post Data', '/home/ViewPosts/viewAllpost', null, 'user', null, false, 0, true), 
    new Menu (45, 'Blank', '/blank', null, 'file-o', null, false, 40, true),
    new Menu (46, 'Error', '/pagenotfound', null, 'exclamation-circle', null, false, 40, true),
  
]